export const DEV = false;

export const domain = 'https://www.myinsurancebroker.com/';
export const quoterurl = 'quoter';
export const RWSURL = '/php/RWSv3new.php?upload';
export const RBURL = '/php/RBv3new.php?upload';
export const EZLURL = '/php/EZLv3new.php?upload';
export const GETMAKE = '/php/get_makenew.php';
export const GETMODEL = '/php/get_modelnew.php';
export const GETCAR = '/php/get_carnew.php';
export const GETPOSTAL = '/php/get_postalnew.php';
export const CRMURL = '/php/hubspotCRM.php';